// @flow

import * as React from 'react';

import Toggle from './Toggle';
import Overlay from './Overlay';
import List from './List';
import Item from './Item';

function columnPickerItems(columns, visibleColumns) {
  return columns
    .filter(column => !column.locked)
    .map(column => {
      return {
        column,
        visible: visibleColumns.includes(column.id)
      };
    });
}

type Props = {
  toggleColumn: string => void,
  columns: Array<{
    id: string,
    locked?: boolean
  }>,
  hiddenColumnNames: Array<string>
};
type State = { visible: boolean };

class ColumnPicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      visible: false
    };
  }
  buttonRef = button => {
    this.button = button;
  };
  handleToggle = () => {
    this.setState({ visible: !this.state.visible });
  };
  handleHide = () => {
    this.setState({ visible: false });
  };

  render() {
    const { toggleColumn, columns, visibleColumns } = this.props;
    const { visible } = this.state;
    return (
      <React.Fragment>
        <Toggle buttonRef={this.buttonRef} onToggle={this.handleToggle} />
        <Overlay
          visible={visible}
          target={this.button}
          onHide={this.handleHide}
        >
          <List>
            {columnPickerItems(columns, visibleColumns).map(item => (
              <Item
                key={item.column.id}
                item={item}
                onToggle={() => toggleColumn(item.column.id, !item.visible)}
              />
            ))}
          </List>
        </Overlay>
      </React.Fragment>
    );
  }
}

export default ColumnPicker;
